export enum Subscription {
  PREMIUM_TRIAL = 'premium-trial', // Free trial premium subscription (30 days)
  PREMIUM_MONTHLY = 'premium-monthly', // Monthly premium subscription (25€/month)
  PREMIUM_ANNUALLY = 'premium-annually', // Yearly premium subscription (180€/year)
  ENTERPRISE = 'enterprise', // Enterprise subscription (contact us)
  PARTNER = 'partner', // Partner subscription (contact us)
}

export const SubscriptionLabels: Record<Subscription, string> = {
  [Subscription.PREMIUM_TRIAL]: 'Premium Trial',
  [Subscription.PREMIUM_MONTHLY]: 'Premium Monthly',
  [Subscription.PREMIUM_ANNUALLY]: 'Premium Annually',
  [Subscription.ENTERPRISE]: 'Enterprise',
  [Subscription.PARTNER]: 'Partner',
}

export default Subscription
